import SectionLabel from '../components/SectionLabel'
import WACTASection from '../components/WACTASection'
import { GUIDE_NAME } from '../constants'

export default function About() {
  return (
    <main style={{ background: 'var(--white)' }}>
      <section style={{ background: 'var(--green-dark)', padding: '100px 5% 80px', color: 'white', textAlign: 'center' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <SectionLabel>Your Guide in Nepal</SectionLabel>
          <h1 className="serif" style={{ fontSize: 'clamp(36px, 6vw, 56px)', fontWeight: 600, color: 'white' }}>
            Direct. Honest. Experienced.
          </h1>
        </div>
      </section>

      <section className="section" style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
        gap: '60px', 
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{ 
          borderRadius: 'var(--radius-lg)', 
          background: 'var(--stone)', 
          height: '480px', 
          border: '1px solid var(--stone-mid)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          color: 'var(--ink-light)', 
          fontSize: '14px',
          padding: '20px'
        }}>
          Guide Portrait Placeholder
        </div>
        <div>
          <h2 className="section-title">I'm {GUIDE_NAME}.</h2>
          <p style={{ fontSize: '16px', color: 'var(--ink-mid)', marginBottom: '24px', lineHeight: 1.8, fontWeight: 300 }}>
            I was born in the foothills of the Himalayas and have spent my life in these mountains. What I've learned is that the best experiences don't come from massive offices in Thamel, but from the personal connection between a guide and their guests.
          </p>
          <p style={{ fontSize: '16px', color: 'var(--ink-mid)', marginBottom: '32px', lineHeight: 1.8, fontWeight: 300 }}>
            I guide independently — a more authentic, direct, and honest experience for trekkers who want to see the real Nepal without the agency markup. You plan your trek directly with me, not a call centre.
          </p>
        </div>
      </section>

      <section className="section bg-stone">
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '48px' }}>Our Philosophy.</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '40px' }}>
            <div>
              <h3 style={{ fontSize: '19px', fontWeight: 600, marginBottom: '14px', fontFamily: 'var(--serif)' }}>Solitude first</h3>
              <p style={{ fontSize: '14px', color: 'var(--ink-mid)', lineHeight: 1.65, fontWeight: 300 }}>
                We choose the quiet trails and authentic villages over the "teahouse highways." If you want to see Nepal as it was 30 years ago, we know where to go.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '19px', fontWeight: 600, marginBottom: '14px', fontFamily: 'var(--serif)' }}>Direct communication</h3>
              <p style={{ fontSize: '14px', color: 'var(--ink-mid)', lineHeight: 1.65, fontWeight: 300 }}>
                You speak directly to me, not a sales agent in an office. This ensures your questions are answered by someone who actually walks the trails.
              </p>
            </div>
            <div>
              <h3 style={{ fontSize: '19px', fontWeight: 600, marginBottom: '14px', fontFamily: 'var(--serif)' }}>Sustainable guiding</h3>
              <p style={{ fontSize: '14px', color: 'var(--ink-mid)', lineHeight: 1.65, fontWeight: 300 }}>
                By booking direct, more for your money goes to the local communities and support staff. We pay our porters 30% above the standard agency rate.
              </p>
            </div>
          </div>
        </div>
      </section>

      <WACTASection />
    </main>
  )
}
